import viridisData from "./raw/viridis.json";

export const viridisColorMap = (type) => {
  if (type === "range") {
    return viridisData;
  }
};
